
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import labelSelect from './label-select.vue'
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from '@/utils/util'
import AreaSelect from '@/components/area-select.vue'
import { apiAllTagList } from '@/api/operating/group_welfare/tag'
import { apiActivityPointList, apiShopPutLists } from '@/api/operating/group_welfare/point'
import { apiActivityDelPut, apiActivityPut } from '@/api/operating/group_welfare/activity'
@Component({
  components: {
    labelSelect,
    lsPagination,
    AreaSelect
  }
})
export default class SetPoint extends Vue {
  $refs!: { table: any };
  @Prop() value!: boolean
  @Prop({default: () => {}}) data!: any // 投放类型 0-指定点位投放 1-按区域和标签投放
  @Prop({default: ()=> []}) pointIds!: number[] // 指定点位ID列表
  @Prop({default: ()=> []}) labelIds!: number[] // 标签ID列表
  @Prop({default: ()=> []}) area!: number[] // 标签ID列表
  @Prop({default: 0}) filterStatus!: number // 投放筛选状态 0-未投放 1-已投放
  
  /** S Data*/
  pager: RequestPaging = new RequestPaging()
  query:any = {}
  labelList:any = []
  pointSelectIds:any = []
  type = 0
  is_all = 0
  form:any = {
    pointIds: [],
    labelIds: [],
  }
  areaIds = []
  /** E Data*/
  
  /** S computed*/
  get show():boolean {
    return this.value
  }
  set show(val) {
    this.$emit('input', val)
  }
  @Watch('data', { immediate: true, deep: true })
  paramChange(val: number) {
    if (!val) return
    this.form = val
  }
  @Watch('value')
  valueChange(val:any) {
    if (this.value) {
      this.getLabelList()
      this.getPointList(1)
    }
  }
  
  /** D computed*/
  
  /** S Method*/
  getLabelList() {
    apiAllTagList().then(res => {
      this.labelList = [];
      res.map((tag:any) => {
        tag.tag.map((item:any) => {
          this.labelList.push(item)
        })
      })
    })
  }
  handleSelectAll(val:any) {
    let curr = val.map((item:any) => item.id)
    let checked:any = []
    let nochecked:any = []
    this.pager.lists.map((item:any) => {
      console.log(curr.indexOf(item.id))
      if (curr.indexOf(item.id) >= 0) {
        checked.push(item.id)
      } else {
        nochecked.push(item.id)
      }
    })
    checked.map((item:any) => {
       let index = this.pointSelectIds.indexOf(item)
        if (index < 0) {
          this.pointSelectIds.push(item)
        }
    })
    nochecked.map((item:any) => {
      let index = this.pointSelectIds.indexOf(item)
      if (index >= 0) {
        this.pointSelectIds.splice(index, 1)
      }
    })
  }
  getPointList(page?:number) {
    page&&(this.pager.page = page)
    this.query.activity_id = this.form.id
    this.query.filter = this.filterStatus;
    this.pager.request({
      callback: apiActivityPointList,
      params: {
        ...this.query
      }
    }).then(res => {
      res.lists.map((item:any) => {
        console.log(this.data)
        if (this.data.pointIds.indexOf(item.id) >= 0) {
          this.$refs.table.toggleRowSelection(item)
        }
      })
    })
  }
  selectArea(data:any) {
    // console.log(data)
    this.areaIds = data;
    this.form.areaIds = data.map((item:any) => item[2]);
  }
  submit() {
    if (this.filterStatus == 0) {
      this.doPut()
    } else {
      this.doDel()
    }
  }
  doPut() {
    this.form.type = this.type
    this.form.isAll = this.is_all;
    if (this.type == 0) {
      if (this.is_all != 1 && this.pointSelectIds.length <= 0) {
        this.$message.error('请选择投放点位')
        return
      }
      this.form.pointIds = this.pointSelectIds
    } else {
      if (!this.form.areaIds) {
        this.$message.error('请选择投放区域')
        return
      }
      if (this.form.labelIds.length <= 0) {
        this.$message.error('请选择标签')
        return
      }
    }
    apiActivityPut(this.form).then(res => {
      this.show = false
      this.$emit('success')
    })
  }
  doDel(ids:any = []) {
    if (!ids.length) {
      ids = this.pointSelectIds
    }
    if (!ids) {
      this.$message.error('请选择点位')
      return
    }
    this.form.pointIds = ids
    this.form.isAll = this.is_all;
    this.$confirm(`确认移除点位吗？`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiActivityDelPut(this.form).then(res => {
        this.show = false
        this.$emit('success')
      })
    }).catch(() => {})
   
  }
  
  /** E Method*/
  created() {
    this.pointSelectIds = []
    this.labelList = []
    this.form = {
      pointIds: [],
      labelIds: [],
    }
  }
}
